import { call, put, select, takeLatest } from "redux-saga/effects";
import qs from 'qs';
import { FETCH_INCREASE_DEAL_SIZE_CARD_REQUEST, fetchIncreaseDealSizeCardFailure, fetchIncreaseDealSizeCardSuccess } from "../../actions/opportunities/increaseDealSizeCardActions";
import iq_api_v2 from "../../../../services/iqApiV2";

async function findIncreaseDealSizeCardData(deal_id="") {
  
    // console.log("data",data)
    try {
      const response = await iq_api_v2.get("/deals/get_deal_card?deal_id="+deal_id, '');
      // console.log('Response:', response.data);
      return response?.data || []
    } catch (error) {
      console.error('Error:', error.response ? error.response.data : error.message);
    }
  }

// Worker Saga
function* fetchIncreaseDealSizeCardSaga() {
  try {
    const payload = yield select(
      (state) => state?.increaseDealSizeCardReducer?.payload
    );
    const { deal_id=""} = payload;
    const data = yield call(
        findIncreaseDealSizeCardData,
        deal_id
    );
    yield put(fetchIncreaseDealSizeCardSuccess(data));
  } catch (error) {
    yield put(fetchIncreaseDealSizeCardFailure(error.message));
  }
}

// Watcher Saga
export function* watchIncreaseDealSizeCardData() {
  yield takeLatest(FETCH_INCREASE_DEAL_SIZE_CARD_REQUEST, fetchIncreaseDealSizeCardSaga);
}
